import STALE_TIMES from '../common/stale-times'

const useStaleTimes = () => {
    return STALE_TIMES
}

export default useStaleTimes